import styled from 'styled-components';
import { Heading } from '../UsabilityTest.styles';

export const IntroHeading = styled(Heading)`
    margin: 20px 0 0 0;
`;
